import { Flex } from "@chakra-ui/react";
import { MdSwapVert } from "react-icons/md";
import colors from "core/resources/theme/colors";
import ModalOrderBy from "../ModalOrderBy";
import { useState } from "react";

interface OrderByButtonProps {
  onOrderDirectionChange: (q?: string) => void;
  orderDirection?: string | undefined;
  onOrderByChange: (q?: string) => void;
  orderBy?: string | undefined;
  options: {
    value: string;
    label: string;
  }[];
}

export default function OrderByButton({
  onOrderDirectionChange,
  orderBy,
  orderDirection,
  onOrderByChange,
  options,
}: OrderByButtonProps) {
  const [openModal, SetOpenModal] = useState(false);
  return (
    <>
      <Flex
        color={colors.blue}
        fontSize="16px"
        gap={2}
        align="center"
        onClick={() => SetOpenModal(true)}
        cursor="pointer"
        userSelect="none"
      >
        <MdSwapVert size={20} /> Ordenar por
      </Flex>
      <ModalOrderBy
        onClose={() => SetOpenModal(false)}
        openModal={openModal}
        onOrderDirectionChange={onOrderDirectionChange}
        orderDirection={orderDirection}
        orderBy={orderBy}
        onOrderByChange={onOrderByChange}
        options={options}
      />
    </>
  );
}
